type TAppLoaderProps = {
  className?: string;
};

export function AppLoader({ className }: TAppLoaderProps) {
  return (
    <div className={`flex justify-center items-center h-64 ${className}`}>
      <div className="w-12 h-12 border-t-2 border-b-2 border-gray-500 rounded-full animate-spin"></div>
    </div>
  );
}
